import { CandidateProfileTab } from 'modules/candidate-profile/utils/getCandidateProfileTabs';
import { CandidateProfileDocumentsTab } from 'modules/candidate-profile/tabs/CandidateProfileDocumentsTab';
import { CandidateProfileApplicantsTab } from 'modules/candidate-profile/tabs/CandidateProfileApplicantsTab';
import { CandidateProfileInvitationsTab } from 'modules/candidate-profile/tabs/CandidateProfileInvitationsTab';
import { CandidateProfileConversationsTabs } from 'modules/candidate-profile/tabs/CandidateProfileConversationsTabs';
import {
  CandidateProfileProfileTab,
  CandidateProfileProfileTabProps
} from 'modules/candidate-profile/tabs/CandidateProfileProfileTab';
import { TabComponents } from 'common/types/tabsV2';

type GetCandidateProfileTabComponentsProps = CandidateProfileProfileTabProps;

export const getCandidateProfileTabComponents = ({
  candidateProfile
}: GetCandidateProfileTabComponentsProps): TabComponents<CandidateProfileTab> => ({
  Profile: <CandidateProfileProfileTab candidateProfile={candidateProfile} />,
  Invited: <CandidateProfileInvitationsTab />,
  Applied: <CandidateProfileApplicantsTab />,
  Documents: <CandidateProfileDocumentsTab />,
  'Other campaigns': <CandidateProfileConversationsTabs />
});
